import ExcelJS from 'exceljs';
import type { AllocationsByClientRow, ExportProgressHandler, MonthRange } from '../exportsPage.types';
import { aggregateAllocationsByClient, downloadWorkbook, formatMonthLabel } from '../utils';
import { fetchAllocationExportItems } from './allocationsData';

/** Monta a planilha a partir das linhas já agregadas. */
function buildWorkbook(rows: AllocationsByClientRow[], range: MonthRange): ExcelJS.Workbook {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alocações por Cliente');

    worksheet.columns = [
        { header: 'Cliente', key: 'clientName', width: 40 },
        { header: 'Mês', key: 'month', width: 14 },
        { header: 'Tipo de Escopo', key: 'scopeTypeLabel', width: 24 },
        { header: 'Pessoas Alocadas', key: 'peopleCount', width: 20 },
    ];

    worksheet.getRow(1).font = { bold: true };

    rows.forEach((row) => {
        worksheet.addRow(row);
    });

    worksheet.getColumn('peopleCount').alignment = { horizontal: 'right' };
    worksheet.autoFilter = { from: 'A1', to: 'D1' };
    worksheet.views = [{ state: 'frozen', ySplit: 1 }];

    worksheet.getCell('A1').note = {
        texts: [
            {
                font: { size: 10, name: 'Calibri', family: 2 },
                text:
                    `Período: ${formatMonthLabel(range.start)} a ${formatMonthLabel(range.end)}.\n\n` +
                    'Cada linha conta pessoas distintas alocadas naquele cliente, mês e tipo de escopo.\n' +
                    'A pessoa conta no mês se a alocação cobrir ao menos um dia dele.\n' +
                    'Alocações canceladas e tipos sem cliente (Interno, Ausência, Comercial, Aviso Prévio) ficam de fora.',
            },
        ],
        margins: { insetmode: 'custom', inset: [0.25, 0.25, 0.35, 0.35] },
    };

    return workbook;
}

/**
 * Exporta a lista de alocações cliente x mês dentro do intervalo informado.
 * Retorna quantas linhas foram geradas.
 */
export async function exportAllocationsByClient(
    range: MonthRange,
    onProgress?: ExportProgressHandler
): Promise<number> {
    const items = await fetchAllocationExportItems(onProgress);
    const rows = aggregateAllocationsByClient(items, range);
    const workbook = buildWorkbook(rows, range);

    await downloadWorkbook(workbook, `alocacoes-por-cliente-${range.start}_${range.end}.xlsx`);

    return rows.length;
}
